var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#FCFCFC",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0837 5.64749C16.57 6.13749 16.567 6.92894 16.077 7.41524L8.88149 14.5563C8.39543 15.0386 7.61171 15.0401 7.12382 14.5596L3.94232 11.426C3.45048 10.9416 3.44447 10.1501 3.92891 9.6583C4.41334 9.16646 5.20478 9.16045 5.69662 9.64489L7.99764 11.9112L14.3159 5.64077C14.8059 5.15448 15.5974 5.15748 16.0837 5.64749Z"
  })));
};
export default SvgCheck;